/*
 * @Author: Gang Jiang 
 * @Date: 2024-10-12 09:12:17 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-28 14:21:44
 */
export const TABLE_COLUMNS = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  {
    dataIndex: 'status',
    key: 'Status',
    width: 75,
    titleTip: `Commission's item-based status, we have unified 5 statuses based on the status of the affiliate order info to track the status transfer of the commissions.
    <ul class="status-tip-list">
      <li><b>Open</b>: Commission that has not yet been confirmed, affiliate generated item orders with approved and unapproved commissions.</li>
      <li><b>DM Received</b>: Finance confirmed receipt of money from bank account.</li>
      <li><b>Pending Payment</b>: Both Finance and IM have confirmed the Influencer bill and are awaiting payment to influencer before the payment date.</li>
      <li><b>Paid</b>: Commissions has been paid to influencer, and finance has uploaded the receipt of payment in the system.</li>
      <li><b>Declined</b>: Affiliate updated the orders and this commission transiction was marked as fully returned.</li>
    </ul>`,
  },
  {
    dataIndex: 'eventTime',
    key: 'Event Time',
    width: 150,
    titleTip: 'Commission creation time from affiliate.',
  },
  {
    dataIndex: 'updateTime',
    key: 'Update Time',
    width: 150,
    titleTip: "Commission's last update time in the inrewards system.",
  },
  {
    title: 'UserID',
    dataIndex: 'influencerId',
    key: 'influencerId',
    width: 60,
  },
  {
    title: 'Sub User ID',
    dataIndex: 'subInfluencerId',
    key: 'subInfluencerId',
    width: 86,
  },
  {
    title: 'Username',
    dataIndex: 'influencerUsername',
    key: 'influencerUsername',
    width: 80,
  },
  {
    dataIndex: 'advertiser',
    key: 'Advertiser Name',
    width: 168,
    titleTip: `The name of the merchant from affiliate, same as affiliate's.`,
  },
  {
    dataIndex: 'itemTitle',
    key: 'Item Title',
    width: 150,
    titleTip: `Original item title from affiliate order info.`,
  },
  {
    dataIndex: 'originalSales',
    key: 'O.Sales',
    width: 90,
    titleTip: 'Amount of sales in the original currency from the affiliate.',
  },
  {
    dataIndex: 'originalCommission',
    key: 'O.Commission',
    width: 130,
    titleTip:
      'Amount of Commission in the original currency from the affiliate.',
  },
  {
    dataIndex: 'cancelSales',
    key: 'cancelSales',
    width: 90,
    title:'Cancel Sales'
  },
  {
    dataIndex: 'cancelCommission',
    key: 'cancelCommission',
    width: 100,
    title:'Cancel Commission'
  },
  {
    dataIndex: 'cancelReason',
    key: 'cancelReason',
    width: 100,
    title:'Cancel Reason'
  },
  {
    dataIndex: 'type',
    key: 'Type',
    width: 68,
    titleTip:
      'Mark whether the commission transiction is a sales revenue record, or a return refund record, or the operation rejected record.',
  },
  {
    dataIndex: 'commissionCurrency',
    key: 'Currency',
    width: 90,
    titleTip: 'Original commission currency from affiliate.',
  },
  {
    dataIndex: 'currencyRate',
    key: 'Currency Rate',
    width: 120,
    titleTip: `Before financial confirmation, the estimated exchange rate is from the exchange rate of the 1st of the month provided by the third party API, after the finance's confirmation,  it will be replace with the actual exchange rate filled by finance.`,
  },
  {
    dataIndex: 'salesUsd',
    key: 'Sales $',
    width: 95,
    titleTip: `The sales amount in USD according to the currency rate.`,
  },
  {
    dataIndex: 'commissionUsd',
    key: 'Commission $',
    width: 135,
    titleTip: `The commission amount in USD according to the currency rate.`,
  },
  {
    dataIndex: 'commissionForKolUsd',
    key: 'Commission for KOL $',
    width: 180,
    titleTip: `The commission amount in USD converted to influencer's commission according to the Comission for KOL Ratio.`,
  },
  {
    dataIndex: 'commissionForKolRatio',
    key: 'Commission for KOL Ratio',
    width: 203,
    titleTip:
      'Specific ratio assigned to influencer, which is recorded when buyer clicking on the tracking link.',
  },
  {
    dataIndex: 'affiliate',
    key: 'Affiliate',
    width: 180,
    titleTip: 'Affiliate name.',
  },
  {
    dataIndex: 'advertiserId',
    key: 'Advertiser ID',
    width: 125,
    titleTip: `The ID of the merchant from affiliate, same as affiliate's.`,
  },
  {
    dataIndex: 'orderId',
    key: 'Order ID',
    width: 100,
    titleTip: `Order ID from affiliate's order info.`,
  },
  {
    dataIndex: 'commissionId',
    key: 'Commission ID',
    width: 135,
    titleTip: `Commission ID from affiliate order info.`,
  },
  {
    dataIndex: 'itemId',
    key: 'Item ID(SKU)',
    width: 123,
    titleTip: `Item ID from affiliate order info, some affiliates call it SKU ID.`,
  },
  {
    dataIndex: 'itemCategory',
    key: 'Item Category',
    width: 150,
    titleTip: `Original item category from affiliate order info.`,
  },
  {
    dataIndex: 'affiliatePid',
    key: 'Affiliate PID',
    width: 114,
    titleTip: `Our registered account PID in affiliate, it is used to identify which affiliate the merchant is from.`,
  },
  {
    dataIndex: 'affiliateMid',
    key: 'Affiliate MID',
    width: 118,
    titleTip: `Merchant MID from affiliate, different for each affiliate, used to identify the merchant.`,
  },
  {
    dataIndex: 'trackingId',
    key: 'Tracking ID',
    width: 300,
    titleTip: `Tracking ID in the inrewards tracking link, returned from affiliate.`,
  },
  {
    dataIndex: 'shortLink',
    key: 'Inrwd Link',
    width: 180,
    titleTip: `The inrewards tracking link generated by the influencer.`,
  },
  {
    dataIndex: 'affiliatePaymentId',
    key: 'Affiliate Payment ID',
    width: 188,
    titleTip: `The payment ID from the affiliate's payment info associated with the commission.`,
  },
  {
    dataIndex: 'note',
    key: 'Note',
    width: 200,
    titleTip: `Notes or remarks filled by the operators.`,
  },
 
  {
    title: 'Actions',
    width: 100,
    dataIndex: 'actions',
    key: 'actions',
    fixed: 'right',
  },
]

export const getElementPosition = (element, parent) => {
  // 获取元素相对于视口的位置
  const rect = element.getBoundingClientRect()

  // 计算父元素的偏移
  const parentRect = parent.getBoundingClientRect()

  return {
    top: rect.top - parentRect.top + parent.scrollTop + 2 + 'px',
    left: rect.left - parentRect.left + parent.scrollLeft + 1 + 'px',
  }
}